import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TitleModal(props: any) {
  const { visible, onClose, onConfirm, content, isLoading } = props;
  const { t } = useTranslation();

  const useToggle = (defaultValue: boolean) => {
    const [value, setValue] = useState(defaultValue);
    const toggle = () => setValue((value) => !value);
    return [value, toggle];
  };

  const [isOverlayVisible] = useToggle(true);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={!isLoading}
      closeOnOutsideClick={false}
      isClosable={!isLoading}
      isOpen={visible}
      onClose={onClose}
      size="sm"
    >
      {isOverlayVisible && <ModalOverlay opacity={0.9} />}
      <ModalContent minHeight="200px">
        <ModalBody>
          <Text mb="8x">{content}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {t('common.button.ok')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose} disabled={isLoading}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
